import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderNewsAdvertisement() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 1500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    '@0.75': {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    '@1.00': {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                    '@1.50': {
                        slidesPerView: 3,
                        spaceBetween: 50,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/22.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/22.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/23.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/23.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/24.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/24.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/1.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/1.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/2.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/2.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/3.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/3.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/4.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/4.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/5.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/5.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/6.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/6.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/7.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/7.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/8.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/8.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/9.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/9.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/10.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/10.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/11.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/11.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/12.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/12.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/13.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/13.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/14.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/14.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/15.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/15.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/16.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/16.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/17.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/17.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/18.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/18.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/19.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/19.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/20.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/20.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/News Advertisement/21.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/News Advertisement/21.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">News</h5>
                        </div>
                    </div>
                </SwiperSlide>

              
            </Swiper>
        </>
    );
}
